/**
 * The collection model for resource at the LSCloud /API/Account/Option REST endpoint
 */

import Option from 'app/src/data/models/Option';
import RetailCollection from 'app/src/data/models/RetailCollection';
import URLHelper from 'app/src/data/models/utils/URLHelper';

export default class OptionCollection extends RetailCollection {
  get model() {
    return Option;
  }

  /**
   * Return the REST url for collection of Options
   * @returns {string} the url representing the REST endpoint
   */
  url() {
    return URLHelper.getAccountURL('/Option.json');
  }

  /**
   * Overridden to parse out superfluous json that the current LSCloud returns us
   * @param response
   * @returns {*}
   */
  parse(response) {
    // response.Option is an array of the Option structures we want.
    // Return it directly if an object is found; otherwise return an empty array and let
    // Backbone handle it
    return response.Option || [];
  }
}
